const SIGNALR_EVENT_NAMES = {
  // These are the signalR events that app receives from backend services.
  DEFAULT: {
    notificationUpdated: 'notificationUpdated'
  },
  IBPLANNING: {
    dynamicRoutingCompleted: 'dynamicRoutingCompleted',
    dynamicRoutingFailed: 'dynamicRoutingFailed',
    routingProgress: 'routingProgress',
    routePublishCompleted: 'routePublishCompleted',
    routePublishFailed: 'routePublishFailed',
    etlStarted: 'etlStarted',
    etlCompleted: 'etlCompleted',
    etlFailed: 'etlFailed',
    shipmentDetected: 'shipmentDetected'
  },
  DISPATCH: {
    dispatchCancelled: 'dispatchCancelled',
    pickupAssigned: 'pickupAssigned',
    pickupUnassigned: 'pickupUnassigned',
    driverAssigned: 'driverAssigned',
    driverRouteUpdated: 'driverRouteUpdated',
    proAdded: 'proAdded',
    dollyDropHookProcessed: 'dollyDropHookProcessed',
    trailerHooked: 'trailerHooked',
    trailerDropped: 'trailerDropped',
    bobtailProcessed: 'bobtailProcessed',
    moveBillsProcessed: 'moveBillsProcessed',
    dispatchUpdate: 'dispatchUpdate',
    proDeleted: 'proDeleted',
    plannedKPIUpdated: 'plannedKPIUpdated',
    pickupUpdated: 'pickupUpdated',
    duplicatePickupsDetected: 'duplicatePickupsDetected',
    locationUpdated: 'locationUpdated',
    messageFromDriver: 'messageFromDriver',
    messageRead: 'messageRead',
    driverLoginStatusUpdate: 'driverLoginStatusUpdate',
    driverDispatched: 'driverDispatched',
    stopMoved: 'stopMoved',
    trailerStatusUpdated: 'trailerStatusUpdated',
    pickupAcknowledged: 'pickupAcknowledged',
    pickupsMerged: 'pickupsMerged',
    accessibleTerminalUpdated: 'accessibleTerminalUpdated',
    kpiUpdated: 'kpiUpdated',
    pickupRecommendationsAvailable: 'pickupRecommendationsAvailable',
    geofenceArrivalDeparture: 'geoFenceArrivalDeparture',
    shipperUpdatedFromIBPlanning: 'shipperUpdatedFromIBPlanning',
    revisitDeliveryStop: 'revisitDeliveryStop',
    trailerClosed: 'trailerClosed',
    trailerMovesUpdated: 'trailerMovesUpdated',
  }
};

const APP_EVENT_NAMES = {
  //These are the events that are emitted on the app side to update different components subscribed to it.
  DEFAULT: {
    UpdateNotifications: 'UpdateNotifications'
  },
  IBPLANNING: {
    RoutingStatus: 'RoutingStatus',
    RoutePublishCompleted: 'RoutePublishCompleted',
    ETLProgress: 'ETLProgress',
    NewShipmentsDetected: 'NewShipmentsDetected',
    openUnrtdModal: 'openUnrtdModal',
    ClearETLCityRoutes: 'ClearETLCityRoutes'
  },
  DISPATCH: {
    RefreshDispatchStore: 'RefreshDispatchStore',
    HandlePickupEvent: 'HandlePickupEvent',
    HandleTrailerMovesEvent: 'HandleTrailerMovesEvent',
    DeliveryCompleted: 'DeliveryCompleted',
    RefreshPickupsData: 'RefreshPickupsData',
    NextStopChanged: 'NextStopChanged',
    PickupCompleted: 'PickupCompleted',
    UpdateDriverRoute: 'UpdateDriverRoute',
    proAdded: 'proAdded',
    refreshDolly: 'refreshDolly',
    dollyHooked: 'dollyHooked',
    equipmentDropped: 'equipmentDropped',
    UpdateSpottedTrailers: 'UpdateSpottedTrailers',
    trailerHooked: 'trailerHooked',
    bobtailProcessed: 'bobtailProcessed',
    MoveBills: 'MoveBills',
    RefreshEquipmentData: 'RefreshEquipmentData',
    EquipmentDefectsUpdated: 'EquipmentDefectsUpdated',
    AssetUpdateDefects: 'AssetUpdateDefects',
    EndOfTripCompleted: 'EndOfTripCompleted',
    refreshAvailableDrivers: 'refreshAvailableDrivers',
    AssetDollyUpdate: 'AssetDollyUpdate',
    AssetTractorUpdate: 'AssetTractorUpdate',
    RefreshTrailersData: 'RefreshTrailersData',
    proDeleted: 'proDeleted',
    refreshDispatchKPI: 'refreshDispatchKPI',
    showPickupTerminalChangeMessage: 'showPickupTerminalChangeMessage',
    VoidAndUnvoidPickup: 'VoidAndUnvoidPickup',
    NoFreightForUnassignedPickup: 'NoFreightForUnassignedPickup',
    updatePickupListInStore: 'updatePickupListInStore',
    RefreshDuplicatePickups: 'RefreshDuplicatePickups',
    AddDriverLocation: 'AddDriverLocation',
    MessageFromDriver: 'MessageFromDriver',
    DispatcherMessageRead: 'DispatcherMessageRead',
    UpdateDriverLoginStatus: 'UpdateDriverLoginStatus',
    DriverDispatched: 'DriverDispatched',
    stopMoved: 'stopMoved',
    UpdatePickupAcknowledgedStatus: 'UpdatePickupAcknowledgedStatus',
    MergePickups: 'MergePickups',
    RefreshAccessibleTerminals: 'RefreshAccessibleTerminals',
    updateKPIData: 'updateKPIData',
    RefreshPickupRecommendations: 'RefreshPickupRecommendations',
    GeofenceArrivalDeparture: 'GeofenceArrivalDeparture',
    updateDriverGateinGateout: 'updateDriverGateinGateout',
    dispatchCanceled: 'dispatchCanceled',
    DispatchStartTripCompleted:'DispatchStartTripCompleted',
    ClosedTrailersUpdated: 'ClosedTrailersUpdated',
    ClosedTrailerStatusUpdated: 'ClosedTrailerStatusUpdated',
    UpdatedClosedTrailers: 'UpdatedClosedTrailers',
    ClosedRevisitStop: 'ClosedRevisitStop',
    NavigateToToBeReviewedPickup: 'NavigateToToBeReviewedPickup',
    TrailerMovesUpdated: 'TrailerMovesUpdated',
  }
};

const DISPATCH_SUB_EVENTS = {
  dispatchCanceled: 'dispatchCanceled',
  StopsCompleted: 'StopsCompleted',
  NextStopChanged: 'NextStopChanged',
  EndOfTrip: 'EndOfTrip',
  PickupCompleted: 'PickupCompleted',
  NoFreightPickedUp: 'NoFreightPickedUp',
  AddProToCompletedPickup: 'AddProToCompletedPickup',
  EquipmentDefectUpdated: 'EquipmentDefectUpdated',
  UpdateDriverSchedule: 'UpdateDriverSchedule',
  ChangePickupTerminal: 'ChangePickupTerminal',
  ShipperLocationUpdate: 'ShipperLocationUpdate',
  EnterTerminal: 'EnterTerminal',
  LeaveTerminal: 'LeaveTerminal',
  DispatchStartTrip: 'DispatchStartTrip',
  DispatchUngroupPickup: 'DispatchUngroupPickup'
};

const EVENT_MODES = {
  DELETE: 'DEL',
  ADD: 'ADD',
  UPDATE: 'UPD'
};

export { SIGNALR_EVENT_NAMES, APP_EVENT_NAMES, DISPATCH_SUB_EVENTS, EVENT_MODES };
